export const ActionTypes = {
  LOADING: "GENERATE_AI_SCORING_RUBIC_LOADING",
  ERROR: "GENERATE_AI_SCORING_RUBIC_ERROR",
  SUCCESS: "GENERATE_AI_SCORING_RUBIC_SUCCESS",
};
